import { useEffect, useState } from 'react'

/**
 * The height the page can really use, in px, while ``enabled``: on a phone it shrinks when the
 * keyboard opens (iPhones keep the page's own height and slide the keyboard over it). Null where
 * the browser can't say.
 */
export function useVisualViewportHeight(enabled: boolean) {
  const [height, setHeight] = useState<number | null>(null)
  useEffect(() => {
    const viewport = typeof window === 'undefined' ? undefined : window.visualViewport
    if (!enabled || !viewport) return
    const update = () => {
      // Pinched in, the visible area is only part of the page: keep the page its full height
      // rather than shrinking it to the zoomed view (USA-1537).
      setHeight(viewport.scale > 1.01 ? null : Math.round(viewport.height))
      // Safari scrolls the page up to show the focused box; the page now fits, so put it back.
      if (window.scrollY !== 0) window.scrollTo(0, 0)
    }
    update()
    viewport.addEventListener('resize', update)
    // Safari can also pan the visible area itself when the keyboard opens.
    viewport.addEventListener('scroll', update)
    return () => {
      viewport.removeEventListener('resize', update)
      viewport.removeEventListener('scroll', update)
    }
  }, [enabled])
  return enabled ? height : null
}
